import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { OutlinedInput, Typography, withStyles } from '@material-ui/core';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { API_URL } from '../common/Constants';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';

import swal from '@sweetalert/with-react';

const styles = (theme) => ({
  bg: {
    backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ),url("/images/stamptour_bg.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center 70%',
    backgroundSize: 'cover',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    position: 'absolute',
    wordBreak: 'keep-all',
    [theme.breakpoints.down('sm')]: {
      backgroundPosition: '66% bottom',
    },
  },
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  paper: {
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)',
    [theme.breakpoints.down('sm')]: {
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '80%',
      height: '100%',
      paddingTop: theme.spacing(1),
    },
  },
  cardContent: {
    padding: theme.spacing(3, 5),
  },
  outerGrid: {
    textAlign: 'center',
  },
  logo: {
    width: 100,
    height: 100,
    marginBottom: theme.spacing(3),
    cursor: 'pointer',
    WebkitTouchCallout: 'none',
  },
  loginTextDiv: {
    display: 'inline-block',
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    fontSize: '2em',
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  inputRoot: {
    borderRadius: 25,
    boxShadow: 'inset 0px 2px 2px 0 rgba(0, 0, 0, 0.04)',
    backgroundColor: '#f2f2f2',
    borderStyle: 'none',
    marginBottom: theme.spacing(1.5),
  },
  inputInput: {
    // padding: '0.8em 1em',
    padding: theme.spacing(1.5, 2.5),
  },
  //버튼
  submitBtn: {
    margin: theme.spacing(1, 0, 2),
    backgroundColor: theme.palette.primary.main,
    borderRadius: 30,
    color: '#fff',
    fontSize: '1.2em',
    fontWeight: 900,
  },
  loginBtn: {
    color: theme.palette.primary.point,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontWeight: 600,
  },
  pwdRule: {
    padding: theme.spacing(0, 0.5),
    fontSize: '0.8em',
    fontWeight: 'normal',
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),
    color: 'rgba(85, 85, 85, 0.5)',
  },
  ctrlLabel: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiFormControlLabel-label': {
        fontSize: '13.5px',
        wordBreak: 'break-all',
      },
    },
  },
  agreeDetail: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  goBackBtnText1: {
    fontSize: '1em',
    display: 'inline',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  goBackBtnText2: {
    fontSize: '1em',
    display: 'inline',
    paddingLeft: '1em',
    paddingRight: '1em',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  goBackBtnText3: {
    fontSize: '1em',
    display: 'inline',
    cursor: 'pointer',
    textDecoration: 'underline',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0.5em',
      display: 'block',
    },
  },
});

class JoinPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
      phone: '',
      isInfoAgree1: 'N',
      isInfoAgree2: 'N',
      privacyDialog: false,
      termsOfUseDialog: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
  }

  handleSignUp() {
    const emailRegExp = /\b[\w._-]+@[\w.-]+\.\w{2,4}\b/gi;
    const pwdRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z_\d\W]{8,}$/gi;
    const telRegExp = /^01([0|1|6|7|8|9]?)(\d{3,4})(\d{4})$/gi;

    if (!emailRegExp.test(this.state.email)) {
      swal({
        text: '이메일 주소를 올바르게 입력해주세요.',
        button: '확인',
      }).then(() => {
        this.setState({ email: '' }, () => {
          document.getElementById('email').focus();
        });
      });
      return false;
    } else if (!pwdRegExp.test(this.state.password)) {
      swal({
        text: '비밀번호는 영문, 숫자를 포함하고 8자 이상이어야 합니다.',
        button: '확인',
      }).then(() => {
        this.setState({ password: '' }, () => {
          document.getElementById('password').focus();
        });
      });
      return false;
    } else if (this.state.phone !== '' && !telRegExp.test(this.state.phone)) {
      swal({
        text: '휴대폰 번호를 올바르게 입력해주세요.',
        button: '확인',
      }).then(() => {
        this.setState({ phone: '' }, () => {
          document.getElementById('phone').focus();
        });
      });
      return false;
    } else {
      fetch(`${API_URL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(
          this.state.phone === ''
            ? {
                email: this.state.email,
                name: this.state.name,
                password: this.state.password,
              }
            : {
                email: this.state.email,
                name: this.state.name,
                password: this.state.password,
                phone: this.state.phone,
              },
        ),
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          //console.log(data);
          if (data.msg === 'ALREADY_EXISTS') {
            swal({
              text: '이미 등록된 이메일입니다.',
              button: '확인',
            }).then(() => {
              this.setState({ email: '' });
            });
            return false;
          } else {
            swal({
              text: '회원 가입이 완료되었습니다.',
              button: '확인',
            }).then(() => {
              this.setState({ name: '', email: '', password: '', phone: '', isInfoAgree1: 'N', isInfoAgree2: 'N' }, () => {
                this.props.history.push('login');
              });
            });
          }
        })
        .catch((err) => {
          swal({
            text: '회원 가입에 실패하였습니다. 다시 시도해주세요.',
            button: '확인',
            icon: 'warning',
          });
          console.log(err);
        });
    }
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  //전화번호 입력란 숫자만 입력가능
  handleChangeNum(type, e) {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ [type]: e.target.value });
    }
  }

  openPrivacyDialog = (event) => {
    sessionStorage.setItem('isPrivacyOpen', 'Y');
    this.setState({ privacyDialog: true });
  };

  closePrivacyDialog = (event) => {
    this.setState({ privacyDialog: false });
  };
  openTouDialog = (event) => {
    sessionStorage.setItem('isTermsOfUseOpen', 'Y');
    this.setState({ termsOfUseDialog: true });
  };

  closeTouDialog = (event) => {
    this.setState({ termsOfUseDialog: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.bg}>
          <Container maxWidth="xs" className={classes.container}>
            <Grid container justify="center" alignItems="center" className={classes.paper}>
              <Card style={{ borderRadius: 20 }}>
                <CardContent className={classes.cardContent}>
                  <img
                    src={'/images/doowon_logo_color@2x.png'}
                    className={classes.logo}
                    alt={'doowon_logo'}
                    onClick={() => {
                      this.props.history.push('/');
                    }}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                  <OutlinedInput
                    required
                    fullWidth
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Name *"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    onChange={(e) => {
                      this.handleChange('name', e);
                    }}
                    value={this.state.name}
                  />
                  <OutlinedInput
                    required
                    fullWidth
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Email *"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    onChange={(e) => {
                      this.handleChange('email', e);
                    }}
                    value={this.state.email}
                  />
                  <OutlinedInput
                    required
                    fullWidth
                    id="password"
                    type="password"
                    name="password"
                    placeholder="Password *"
                    style={{ marginBottom: 0 }}
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    onChange={(e) => {
                      this.handleChange('password', e);
                    }}
                    value={this.state.password}
                  />
                  <div className={classes.pwdRule}>* 비밀번호는 영문, 숫자를 포함하고 8자 이상이어야 합니다.</div>
                  <OutlinedInput
                    required
                    fullWidth
                    id="phone"
                    type="tel"
                    name="phone"
                    placeholder="Phone"
                    style={{ marginBottom: 0 }}
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    onChange={(e) => {
                      this.handleChangeNum('phone', e);
                    }}
                    value={this.state.phone}
                  />
                  <div className={classes.pwdRule}>'-' 기호없이 숫자만 입력해주세요.</div>
                  <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', padding: '0 1em' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          value={this.state.isInfoAgree1}
                          color="primary"
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ isInfoAgree1: 'Y' });
                            } else {
                              this.setState({ isInfoAgree1: 'N' });
                            }
                          }}
                        />
                      }
                      labelPlacement="end"
                      label={
                        <div>
                          <span className={classes.agreeDetail} onClick={this.openTouDialog}>
                            <u style={{ color: sessionStorage.getItem('isTermsOfUseOpen') === 'Y' ? '#CCC' : ' #ca502b' }}>이용약관</u>
                          </span>
                          에 동의합니다.
                        </div>
                      }
                      className={classes.ctrlLabel}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          value={this.state.isInfoAgree2}
                          color="primary"
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ isInfoAgree2: 'Y' });
                            } else {
                              this.setState({ isInfoAgree2: 'N' });
                            }
                          }}
                          className={classes.checkbox}
                        />
                      }
                      labelPlacement="end"
                      label={
                        <div>
                          <span className={classes.agreeDetail} onClick={this.openPrivacyDialog}>
                            <u style={{ color: sessionStorage.getItem('isPrivacyOpen') === 'Y' ? '#CCC' : ' #ca502b' }}>
                              개인정보 취급방침
                            </u>
                          </span>
                          에 동의합니다.
                        </div>
                      }
                      className={classes.ctrlLabel}
                    />
                  </div>
                  <Button
                    fullWidth
                    disableElevation
                    variant="contained"
                    className={classes.submitBtn}
                    onClick={this.handleSignUp}
                    disabled={
                      this.state.name === '' ||
                      this.state.position === '' ||
                      this.state.password === '' ||
                      this.state.isInfoAgree1 === 'N' ||
                      this.state.isInfoAgree2 === 'N'
                    }
                  >
                    가입하기
                  </Button>
                  <Typography className={classes.goBackBtnText1}>
                    이미 가입하셨나요?{' '}
                    <span className={classes.loginBtn} onClick={() => this.props.history.push('login')}>
                      로그인하기
                    </span>
                  </Typography>
                  <Typography className={classes.goBackBtnText2}>|</Typography>
                  <Typography className={classes.goBackBtnText3} onClick={() => this.props.history.push('/')}>
                    메인으로 돌아가기
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Container>
          <PrivacyPolicy open={this.state.privacyDialog} onClose={this.closePrivacyDialog} disableBackdrop={false} />
          <TermsOfUse open={this.state.termsOfUseDialog} onClose={this.closeTouDialog} disableBackdrop={false} />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(JoinPage);
